module.exports = __webpack_public_path__ + "static/img/subbanner4.b25fc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/subbanner4.jpg
// module id = gVKy
// module chunks = 1